// Version : 0.0.1
// Author : AGALAYA
// LastEdit : KARTHEESWARAN
//Last ADD : ADDING COMMENTS FOR FUNCTION
// MODFIED DATE:06-08-2025
import ProfileTypes from './profile.types';

/** ***************** GET PROFILE DETAILS START *********************** */
export const getProfileDetailsStart = (getData: any) => ({
	type: ProfileTypes.GET_PROFILE_DETAILS_START,
	payload: getData,
});

// DISPATCHES GET SUCCESS ACTION WITH PROFILE DETAILS
export const getProfileDetailsSuccess = (successData: any) => ({
	type: ProfileTypes.GET_PROFILE_DETAILS_SUCCESS,
	payload: successData,
});

// DISPATCHES GET FAILURE ACTION WITH PROFILE DETAILS
export const getProfileDetailsFailure = (failureData: any) => ({
	type: ProfileTypes.GET_PROFILE_DETAILS_FAILURE,
	payload: failureData,
});

// DISPATCHES GET RESPONSE RESET START ACTION WITH PROFILE DETAILS
export const getProfileDetailsResponseResetStart = () => ({
	type: ProfileTypes.GET_PROFILE_DETAILS_RESPONSE_RESET,
});

// DISPATCHES GET RESPONSE CHANGED ACTION WITH PROFILE DETAILS
export const getProfileDetailsResponseChanged = () => ({
	type: ProfileTypes.GET_PROFILE_DETAILS_RESPONSE_CHANGED,
});
/** ***************** GET PROFILE DETAILS END *********************** */

/** ***************** UPDATE PROFILE DETAILS START *********************** */
export const updateProfileDetailsStart = (updateData: any) => ({
	type: ProfileTypes.UPDATE_PROFILE_DETAILS_START,
	payload: updateData,
});

// DISPATCHES UPDATE SUCCESS ACTION WITH PROFILE DETAILS
export const updateProfileDetailsSuccess = (successData: any) => ({
	type: ProfileTypes.UPDATE_PROFILE_DETAILS_SUCCESS,
	payload: successData,
});

// DISPATCHES UPDATE FAILURE ACTION WITH PROFILE DETAILS
export const updateProfileDetailsFailure = (failureData: any) => ({
	type: ProfileTypes.UPDATE_PROFILE_DETAILS_FAILURE,
	payload: failureData,
});

// DISPATCHES UPDATE RESPONSE RESET START ACTION WITH PROFILE DETAILS
export const updateProfileDetailsResponseResetStart = () => ({
	type: ProfileTypes.UPDATE_PROFILE_DETAILS_RESPONSE_RESET,
});

// DISPATCHES UPDATE RESPONSE CHANGED  ACTION WITH PROFILE DETAILS
export const updateProfileDetailsResponseChanged = () => ({
	type: ProfileTypes.UPDATE_PROFILE_DETAILS_RESPONSE_CHANGED,
});
/** ***************** UPDATE PROFILE DETAILS END *********************** */

/** ***************** UPDATE PASSWORD START *********************** */
export const updatePasswordStart = (updatePasswordData: any) => ({
	type: ProfileTypes.UPDATE_PASSWORD_START,
	payload: updatePasswordData,
});

// DISPATCHES UPDATE SUCCESS ACTION WITH PASSWORD
export const updatePasswordSuccess = (successData: any) => ({
	type: ProfileTypes.UPDATE_PASSWORD_SUCCESS,
	payload: successData,
});

// DISPATCHES UPDATE FAILURE ACTION WITH PASSWORD
export const updatePasswordFailure = (failureData: any) => ({
	type: ProfileTypes.UPDATE_PASSWORD_FAILURE,
	payload: failureData,
});

// DISPATCHES UPDATE RESPONSE RESET ACTION WITH PASSWORD
export const updatePasswordResponseResetStart = () => ({
	type: ProfileTypes.UPDATE_PASSWORD_RESPONSE_RESET,
});

// DISPATCHES UPDATE RESPONSE CHANGED ACTION WITH PASSWORD
export const updatePasswordResponseChanged = () => ({
	type: ProfileTypes.UPDATE_PASSWORD_RESPONSE_CHANGED,
});
/** ***************** UPDATE PASSWORD END *********************** */

/** ***************** GENERATE SECRETE AUTHKEYFUN START *********************** */

export const generateSecreteAuthKeyStart = (updateData: any) => ({
	type: ProfileTypes.GENERATE_SECRETE_AUTHKEY_START,
	payload: updateData,
});

// DISPATCHES GENERATE SUCCESS ACTION WITH SECRETEAUTHKEY
export const generateSecreteAuthKeySuccess = (successData: any) => ({
	type: ProfileTypes.GENERATE_SECRETE_AUTHKEY_SUCCESS,
	payload: successData,
});

// DISPATCHES GENERATE FAILURE ACTION WITH SECRETEAUTHKEY
export const generateSecreteAuthKeyFailure = (failureData: any) => ({
	type: ProfileTypes.GENERATE_SECRETE_AUTHKEY_FAILURE,
	payload: failureData,
});

// DISPATCHES GENERATE RESPONSE RESET START ACTION WITH SECRETEAUTHKEY
export const generateSecreteAuthKeyResponseResetStart = () => ({
	type: ProfileTypes.GENERATE_SECRETE_AUTHKEY_RESPONSE_RESET,
});

// DISPATCHES GENERATE RESPONSE CHANGED START ACTION WITH SECRETEAUTHKEY
export const generateSecreteAuthKeyResponseChanged = () => ({
	type: ProfileTypes.GENERATE_SECRETE_AUTHKEY_RESPONSE_CHANGED,
});
/** ***************** GENERATE SECRETE AUTHKEYFUN END *********************** */

/** ***************** UPDATE PASSWORD START *********************** */
export const updateImageStart = (updateImageData: any) => ({
	type: ProfileTypes.UPDATE_IMAGE_START,
	payload: updateImageData,
});

// DISPATCHES UPDATE SUCCESS ACTION WITH IMAGE
export const updateImageSuccess = (successData: any) => ({
	type: ProfileTypes.UPDATE_IMAGE_SUCCESS,
	payload: successData,
});

// DISPATCHES UPDATE FAILURE ACTION WITH IMAGE
export const updateImageFailure = (failureData: any) => ({
	type: ProfileTypes.UPDATE_IMAGE_FAILURE,
	payload: failureData,
});

// DISPATCHES UPDATE RESPONSE RESET START ACTION WITH IMAGE
export const updateImageResponseResetStart = () => ({
	type: ProfileTypes.UPDATE_IMAGE_RESPONSE_RESET,
});

// DISPATCHES UPDATE RESPONSE CHANGED START ACTION WITH IMAGE
export const updateImageResponseChanged = () => ({
	type: ProfileTypes.UPDATE_IMAGE_RESPONSE_CHANGED,
});
/** ***************** UPDATE PASSWORD END *********************** */
